import Icon, { ProcessingIcon } from '@design-systems/react-icons'
import { InteractiveButton } from 'components/button'
import { IWorkAreaToggleProps } from 'pages/trailer/store-trailer-details/ITrailer'
import { Link } from 'react-router-dom'
import { P, match } from 'ts-pattern'
import { Link as LinkType, getNegativeStyle } from 'utils/data'
import { formatNegative } from 'utils/number-format'

interface IBaseCell {
    value: string
    color?: string
    className?: string
    id?: string
    icon?: React.ReactNode
}

interface ILinkCell extends IBaseCell {
    url: string
}

interface IButtonCell extends IBaseCell {
    link: LinkType
    is_link?: boolean
}

type Cell = IBaseCell | ILinkCell | IButtonCell

export type HandleDataClick = {
    (data: IWorkAreaToggleProps): void
}

type RenderCellProps = {
    cell: Cell
    handleDataClick?: HandleDataClick
    handleClick?: (value: string) => void
    selectedCell: string
    isFooter?: boolean
    isLoading?: boolean
}

export const renderCell = ({
    cell,
    handleClick,
    handleDataClick,
    selectedCell = '',
    isFooter = false,
    isLoading = false,
}: RenderCellProps) => {
    const className = cell.className || ''
    const formattedValue = formatNegative(cell.value)
    const formattedStyle = getNegativeStyle(cell.value)
    const cellToMatch = { ...cell, isFooter }
    const result = match(cellToMatch)
        .with({ url: P.select() }, (url) => (
            <>
                <InteractiveButton style={formattedStyle}>
                    <Link to={url}>{formattedValue}</Link>
                </InteractiveButton>
                {cell.icon && <span className="hc8-ml-3x">{cell.icon}</span>}
            </>
        ))
        .with(
            P.union(
                { link: { href: P.nonNullable } },
                { link: P.when((link) => link && !link.href && !link.drill) },
                { is_link: true },
            ),
            () => {
                const onClickFn = () => {
                    if (handleDataClick && cell?.id) {
                        handleDataClick({
                            value: formattedValue ?? '',
                            id: cell.id,
                        })
                    } else if (handleClick) {
                        handleClick(formattedValue || '')
                    }
                }
                return (
                    <InteractiveButton
                        style={formattedStyle}
                        onClick={onClickFn}
                    >
                        {formattedValue}{' '}
                        {selectedCell === formattedValue && isLoading && (
                            <Icon
                                svg={ProcessingIcon}
                                className="toggle-loading-animation"
                                data-testid="processing-icon"
                                aria-hidden
                            />
                        )}
                    </InteractiveButton>
                )
            },
        )
        .with({ isFooter: true }, () => (
            <strong className={formattedStyle}>{formattedValue}</strong>
        ))
        .otherwise(() => (
            <span
                className={`${formattedStyle}${className.length > 0 ? ' ' + className : ''}`}
            >
                {formattedValue}
                {cell.icon && (
                    <span style={{ marginLeft: '4px' }}>{cell.icon}</span>
                )}
            </span>
        ))

    return result
}
